import { createFileRoute, Link, Outlet, useMatches } from "@tanstack/react-router";

export const Route = createFileRoute("/tools")({
  head: () => ({
    meta: [
      { title: "Free Tools for Trades Contractors — Lehi Trades SEO" },
      {
        name: "description",
        content:
          "Free AI-powered tools for trades contractors — ROI calculator, GMB audit, and more from Lehi Trades SEO.",
      },
      { property: "og:title", content: "Free Tools for Trades Contractors" },
      {
        property: "og:description",
        content: "AI-powered ROI calculator and audits for HVAC, plumbing, electrical, and roofing contractors.",
      },
      { property: "og:url", content: "https://lehitradessaeo.com/tools" },
    ],
    links: [{ rel: "canonical", href: "https://lehitradessaeo.com/tools" }],
  }),
  component: ToolsLayout,
});

function ToolsLayout() {
  const matches = useMatches();
  const isIndex = matches[matches.length - 1]?.routeId === "/tools";

  if (!isIndex) return <Outlet />;

  return (
    <main className="mx-auto max-w-4xl px-6 py-20">
      <header>
        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Free tools</p>
        <h1 className="mt-3 font-display text-4xl tracking-tight md:text-5xl">
          AI-powered tools for trades contractors
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-muted-foreground">
          Use these tools on your own — no email required. They run on the same
          AI models we use in client engagements.
        </p>
      </header>

      <div className="mt-12 grid gap-5 sm:grid-cols-2">
        <Link
          to="/tools/roi-calculator"
          className="group block rounded-2xl border border-border bg-card p-6 transition hover:border-primary/50"
        >
          <h2 className="font-display text-xl tracking-tight">
            Trades Marketing ROI Calculator
          </h2>
          <p className="mt-2 text-sm text-muted-foreground">
            Get a 6-month projection of leads, booked jobs, and revenue lift
            from a trades SEO + Google Ads program — instant, AI-generated.
          </p>
          <span className="mt-4 inline-flex text-sm font-medium text-primary group-hover:underline">
            Open calculator →
          </span>
        </Link>
      </div>
    </main>
  );
}